module.exports = __webpack_public_path__ + "static/media/logo-color.c8b019ec.png";